export default __webpack_public_path__ + "static/media/underline.9175d6ee.svg";